import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import dynamic from 'next/dynamic'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import Subnavigation from './components/Subnavigation'

import Collection from './components/Collection'
import CollectionLibraries from './components/CollectionLibraries'
import CollectionCloudSources from './components/CollectionCloudSources'
import CollectionSourceFunctions from './components/CollectionSourceFunctions'
import CollectionAPI from './components/CollectionApi'
import Processing from './components/Processing'
import ProcessingValidationTransformation from './components/ProcessingValidationTransformation'
import ProcessingDeduplication from './components/ProcessingDeduplication'
import ProcessingGDPRSuppression from './components/ProcessingGdprSuppression'
import Aggregation from './components/Aggregation'
import AggregationIdentityResolution from './components/AggregationIdentityResolution'
import AggregationProfileAPI from './components/AggregationProfileApi'
import AggregationSQLTraits from './components/AggregationReverseEtl'
import AggregationAudienceCreation from './components/AggregationAudienceCreation'
import Delivery from './components/Delivery'
import DeliveryCentrifuge from './components/DeliveryCentrifuge'
import DeliveryDestinations from './components/DeliveryDestinations'
import DeliveryWarehousesETL from './components/DeliveryWarehousesEtl'

import ogImageJpeg from './assets/OgInfrastructure.jpg'

const GettingStarted = dynamic(() => import(`@segment/templates/GettingStarted`))

const InfrastructureView = () => {
  const theme = useTheme()

  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="The Twilio Segment Infrastructure | Twilio Segment"
        pageDescription="Under the hood of the system that processes 1M+ events per second."
        pageOG={ogImageJpeg}
        themeColor={theme.palette.brand.darkAcai[800]}
      >
        <Navigation after={<Subnavigation />} />
        <Hero />
        <Main>
          <Collection />
          <CollectionLibraries />
          <CollectionCloudSources />
          <CollectionSourceFunctions />
          <CollectionAPI />
          <Processing />
          <ProcessingValidationTransformation />
          <ProcessingDeduplication />
          <ProcessingGDPRSuppression />
          <Aggregation />
          <AggregationIdentityResolution />
          <AggregationProfileAPI />
          <AggregationSQLTraits />
          <AggregationAudienceCreation />
          <Delivery />
          <DeliveryCentrifuge />
          <DeliveryDestinations />
          <DeliveryWarehousesETL />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default InfrastructureView
